import { Icon } from '@/components/icons/Icon'
import b from '@/components/ui/buttons.module.css'
import { Sheet } from '@/components/ui/Sheet'
import { promptInstall, useInstallStore } from '@/features/pwa/install'

import s from './StartPrompts.module.css'

/** "Get the townshop.in app" (D-63): the browser's install dialog, or the iPhone Share steps. */
export function InstallSheet({ mode, onClose }: { mode: 'prompt' | 'ios'; onClose: () => void }) {
  const markInstalled = useInstallStore((st) => st.markInstalled)
  return (
    <Sheet title="Get the townshop.in app" onClose={onClose}>
      <div className={s.body}>
        <img className={s.icon} src="/pwa-192.png" alt="" width={64} height={64} />
        {mode === 'ios' ? (
          <ol className={s.steps}>
            <li>
              Tap <Icon name="share" size={16} /> <strong>Share</strong> at the bottom of Safari
            </li>
            <li>
              Choose <strong>Add to Home Screen</strong>, then <strong>Add</strong>
            </li>
          </ol>
        ) : (
          <p className={s.text}>
            Open townshop.in from your home screen like any app — faster, and it works on a slow
            connection. No Play Store download.
          </p>
        )}
        {mode === 'prompt' ? (
          <button
            type="button"
            className={`${b.btn} ${b.primary} ${b.lg}`}
            onClick={() => void promptInstall().then(onClose)}
          >
            Install app
          </button>
        ) : (
          <button
            type="button"
            className={`${b.btn} ${b.primary} ${b.lg}`}
            onClick={() => {
              markInstalled()
              onClose()
            }}
          >
            I’ve added it
          </button>
        )}
        <button type="button" className={`${b.btn} ${b.ghost}`} onClick={onClose}>
          Not now
        </button>
      </div>
    </Sheet>
  )
}
